import React, { useRef, useState, useEffect } from "react";
import { Image } from "react-bootstrap";
import BoletoPremiado from "../Assets/BoletoN.png";
import BoletoNormal from "../Assets/BoletoA.png";

function Ticket({ numeroTicket, esPremiado = false }) {
  const imagenBoleto = esPremiado ? BoletoPremiado : BoletoNormal;
  const numeroTexto = String(numeroTicket ?? "");

  const containerRef = useRef(null);
  const overlayRef = useRef(null);
  const [fontSizePx, setFontSizePx] = useState(null);

  useEffect(() => {
    if (!containerRef.current) return;

    let observer;

    const updateFont = () => {
      try {
        const containerWidth = containerRef.current.clientWidth || 130; // px
        // overlay occupies ~62% of container width (kept from layout)
        const overlayWidth = Math.floor(containerWidth * 0.62);
        const len = Math.max(1, numeroTexto.length);

        // average character width factor (empirical). Use conservative factor to ensure fit.
        const charFactor = 0.55; // px per 1rem ~ 16px; character approx width relative to font-size

            // compute font size in px so that len * (fontSize * charFactor) <= overlayWidth
        // => fontSize <= overlayWidth / (len * charFactor)
        let computed = Math.floor(overlayWidth / (len * charFactor));

        // Clamp to reasonable sizes
        const MAX = 36; // px
        const MIN = 10; // px
        if (computed > MAX) computed = MAX;
        if (computed < MIN) computed = MIN;

        // If overlayRef available, try to fine-tune by measuring actual rendered width
        if (overlayRef.current) {
          // apply immediate style to measure reliably
          let fit = false;
          for (let c = computed; c >= MIN; c--) {
            overlayRef.current.style.fontSize = c + "px";
            // force layout
            const scrollW = overlayRef.current.scrollWidth;
            const clientW = Math.floor(overlayWidth);
            if (scrollW <= clientW) {
              computed = c;
              fit = true;
              break;
            }
          }
          if (!fit) computed = MIN;
        }

        setFontSizePx(computed + "px");
      } catch (e) {
        // fallback
        setFontSizePx(null);
      }
    };

    updateFont();

    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(() => updateFont());
      observer.observe(containerRef.current);
    } else {
      window.addEventListener("resize", updateFont);
    }

    return () => {
      if (observer && containerRef.current) observer.unobserve(containerRef.current);
      else window.removeEventListener("resize", updateFont);
    };
  }, [numeroTexto]);

  const overlayStyle = {
    position: "absolute",
    top: "43%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "62%",
    maxWidth: "100%",
    color: "#121212",
    fontSize: fontSizePx || "1.1rem",
    lineHeight: 1,
    letterSpacing: numeroTexto.length > 8 ? "-0.5px" : "0",
    whiteSpace: "nowrap",
    overflow: "visible",
    display: "block",
  };

  return (
    <div className="m-1 d-flex justify-content-center">
      <div
        ref={containerRef}
        className="position-relative"
        style={{ width: "100%", maxWidth: "130px", aspectRatio: "630 / 394" }}
      >
        <Image
          src={imagenBoleto}
          alt={esPremiado ? "Boleto premiado" : "Boleto"}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
        <div
          ref={overlayRef}
          className="fw-bold text-center ticket-number-overlay"
          style={overlayStyle}
          title={numeroTexto}
        >
          {numeroTexto}
        </div>
      </div>
    </div>
  );
}

export default Ticket;
